import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import ElementPlus from 'element-plus'

import 'element-plus/dist/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'; // Importa el archivo CSS de Bootstrap
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Importa el archivo JS de Bootstrap
import './assets/styles/icons.css';

import './assets/styles/apren.css';
//import './assets/styles/upc-DELETE.css';
import '@fortawesome/fontawesome-free/css/all.css';
import {createHead} from "@vueuse/head"; // Importa el CSS de Font Awesome

const head = createHead();

createApp(App)
    .use(head)
    .use(router)
    .use(i18n)
    .use(store)
    .use(ElementPlus)
    .mount('#app')
